module.exports = __webpack_public_path__ + "img/21.39b40f17.jpg";